import React, { useEffect, useRef, useState } from "react";
import {
    Card,
    CardBody,
    Col,
    Container,
    Row,
    Label,
    CardHeader,
    FormGroup,
    Input,
} from "reactstrap";

import AIAssistantPage from "./AIAssistantPage"

const AIAssistant = ({ isOpen, setIsOpen }) => {
    const [showAIAssistant, setShowAIAssistant] = useState(false);
    const [employeeId, setemployeeId] = useState(0);

    const [position, setPosition] = useState({
        x: window.innerWidth - 78,
        y: window.innerHeight - 158,
    });

    const [dragging, setDragging] = useState(false);

    const dragOffset = useRef({
        x: 0,
        y: 0,
    });

    // Check Employee ID + After Login
    useEffect(() => {
        try {
            const storedEmployeeId = localStorage.getItem("Default_EmployeeID");

            const id = Number(storedEmployeeId);

            setemployeeId(id);

            setShowAIAssistant(id === 1203);

        } catch (error) {
            console.error(
                "Error reading Default_EmployeeID:",
                error
            );

            setShowAIAssistant(false);
        }
    }, []);

    // Drag start
    const handleMouseDown = (e) => {
        e.preventDefault();

        setDragging(true);

        dragOffset.current = {
            x: e.clientX - position.x,
            y: e.clientY - position.y,
        };
    };

    // Drag
    useEffect(() => {
        if (!dragging) return;

        const handleMouseMove = (e) => {
            setPosition({
                x: Math.max(
                    0,
                    Math.min(
                        e.clientX - dragOffset.current.x,
                        window.innerWidth - 58
                    )
                ),

                y: Math.max(
                    0,
                    Math.min(
                        e.clientY - dragOffset.current.y,
                        window.innerHeight - 58
                    )
                ),
            });
        };

        const handleMouseUp = () => {
            setDragging(false);
        };

        window.addEventListener(
            "mousemove",
            handleMouseMove
        );

        window.addEventListener(
            "mouseup",
            handleMouseUp
        );

        return () => {
            window.removeEventListener(
                "mousemove",
                handleMouseMove
            );

            window.removeEventListener(
                "mouseup",
                handleMouseUp
            );
        };
    }, [dragging]);

    const [showAttention, setShowAttention] = useState(true);

    useEffect(() => {
        const timer = setTimeout(() => {
            setShowAttention(false);
        }, 4000);

        return () => clearTimeout(timer);
    }, []);


    // Don't show AI
    if (!showAIAssistant) {
        return null;
    }


    if (isOpen) {
        return (
            <AIAssistantPage isOpen={isOpen} setIsOpen={setIsOpen} login_employeeId={employeeId} />
        );
    }

    // -----------------------------
    // FLOATING AI BUTTON
    // -----------------------------

    return (
        <div
            onMouseDown={handleMouseDown}
            onClick={() => {
                if (!dragging) {
                    setIsOpen(true);
                }
            }}
            title="AI Assistant"
            className={`ai-assistant-button ${showAttention ? "ai-attention" : ""}`}
            style={{
                position: "fixed",
                top: `${position.y}px`,
                left: `${position.x}px`,

                width: "58px",
                height: "58px",

                borderRadius: "50%",

                display: "flex",
                alignItems: "center",
                justifyContent: "center",

                cursor: dragging ? "grabbing" : "grab",

                zIndex: 2147483647,

                userSelect: "none",
                touchAction: "none",
            }}
        >
            {/* AI ICON */}
            <svg
                width="31"
                height="31"
                viewBox="0 0 24 24"
                fill="none"
                className="ai-assistant-icon"
            >
                <defs>
                    <linearGradient
                        id="aiGradient"
                        x1="3"
                        y1="3"
                        x2="21"
                        y2="21"
                    >
                        <stop offset="0%" stopColor="#1976d2" />
                        <stop offset="50%" stopColor="#7b1fa2" />
                        <stop offset="100%" stopColor="#e91e63" />
                    </linearGradient>
                </defs>

                {/* Main sparkle */}
                <path
                    d="M12 2.8L13.75 8.25L19.2 10L13.75 11.75L12 17.2L10.25 11.75L4.8 10L10.25 8.25L12 2.8Z"
                    fill="url(#aiGradient)"
                />

                {/* Small sparkle */}
                <path
                    d="M18.8 14.8L19.65 17.05L21.9 17.9L19.65 18.75L18.8 21L17.95 18.75L15.7 17.9L17.95 17.05L18.8 14.8Z"
                    fill="url(#aiGradient)"
                />

                {/* Tiny sparkle */}
                <circle
                    cx="6"
                    cy="17"
                    r="1.15"
                    fill="#1976d2"
                />
            </svg>

            <style>
                {`
        .ai-assistant-button {
            background:
                linear-gradient(#ffffff, #ffffff) padding-box,
                linear-gradient(
                    135deg,
                    #1976d2,
                    #7b1fa2,
                    #e91e63,
                    #00a896
                ) border-box;

            border: 2px solid transparent;

            box-shadow:
                0 5px 18px rgba(25, 118, 210, 0.16),
                0 2px 6px rgba(0, 0, 0, 0.08);

            transition:
                transform 0.2s ease,
                box-shadow 0.25s ease;
        }

        /* Initial attention */
        .ai-attention {
            animation: aiAttention 1.2s ease-in-out 3;
        }

        @keyframes aiAttention {
            0%, 100% {
                transform: scale(1);
            }

            25% {
                transform: scale(1.12);
                box-shadow:
                    0 8px 30px rgba(25, 118, 210, 0.35),
                    0 0 0 8px rgba(25, 118, 210, 0.08);
            }

            50% {
                transform: scale(1);
            }

            75% {
                transform: scale(1.06);
                box-shadow:
                    0 8px 25px rgba(123, 31, 162, 0.25),
                    0 0 0 5px rgba(123, 31, 162, 0.06);
            }
        }

        .ai-assistant-button:hover {
            transform: scale(1.08);

            box-shadow:
                0 8px 25px rgba(25, 118, 210, 0.25),
                0 3px 10px rgba(123, 31, 162, 0.15);
        }

        .ai-assistant-button:active {
            transform: scale(0.96);
        }

        .ai-assistant-icon {
            animation: aiFloat 3s ease-in-out infinite;
            filter:
                drop-shadow(0 2px 4px rgba(25, 118, 210, 0.18));
        }

        @keyframes aiFloat {
            0%, 100% {
                transform: translateY(0) rotate(0deg);
            }

            50% {
                transform: translateY(-2px) rotate(3deg);
            }
        }
    `}
            </style>
        </div>
    );
};
export default AIAssistant;